import { callApi } from './api';

export const fetchMeApi = () =>
  callApi({ method: 'GET', endpoint: '/users/me' });

export const fetchMeProductsApi = () =>
  callApi({ method: 'GET', endpoint: '/users/me/products' });

export const fetchOpenTicketApi = body =>
  callApi({
    method: 'POST',
    endpoint: `/users/open_ticket`,
    body,
  });
